<div class="contact">
  <p
    class="contact-telephone"
    (click)="onPhoneClick()"
    (keydown)="onPhoneClick()"
    [innerHTML]="'header.' + type() + '.openingDays' | translate"
    role="button"
    tabindex="0"
  ></p>
  <div class="contact-timetables">
    <div class="desktopOnly">
      <p [innerHTML]="'header.' + type() + '.openingHours.desktop.week' | translate"></p>
    </div>
    <div class="mobileOnly">
      <p>
        {{ 'header.' + type() + '.openingHours.mobile.week' | translate }}
      </p>
    </div>
  </div>
</div>
